export { ProductPageContainer } from "./components/containers/ProductPageContainer/ProductPageContainer.jsx";
export { productPageRequest } from "./components/containers/ProductPageContainer/ProductPageRequest.js";